import { useEffect, useState } from 'react';
import ContentWrapper from '../../views/components/ContentWrapper';
import { getUsers } from '../../data/dataApi';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Pagination from '../../views/components/Pagination';
import { roles } from '../../views/helpers';
import { useUserState } from '../../views/components/Mode';

const UserAccounts = () => {
    const { userRole } = useUserState();

    const [users, setUsers] = useState([]);

    const { page } = useParams();

    const listLimit = 20;

    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            const response = await getUsers(page === undefined ? 0 : page - 1);

            response.success && setUsers(response.data.rows);
        })();
    }, [page]);

    return (
        <ContentWrapper>
            <div id="user-accounts" className="wrapper">
                {
                    userRole === "admin" &&
                    <div className="d-flex justify-content-end tif-pb-md-35 tif-pb-20">
                        <Link id="add-new-user-btn" to="/user-accounts/add" className="quinary-btn">+ <u>Add new user</u></Link>
                    </div>
                }
                <table className='primary-table'>
                    <thead>
                        <tr>
                            <td>Name</td>
                            <td>Email Address</td>
                            <td>Role</td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            users.map((user) =>
                                <tr key={ user.id } onClick={() => navigate(`/user-accounts/${ user.id }`)}>
                                    <td>{ user.name }</td>
                                    <td>{ user.email }</td>
                                    <td>{ roles[user.role] }</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>

                <Pagination listLength={ users.length && users[0].total_count } path="/user-accounts" page={ page } limit={ listLimit } />
            </div>
        </ContentWrapper>
    );
};

export default UserAccounts;
